const getCookie = (name) => {
  const regex = new RegExp(
    `(?:^|; )${name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1")}=([^;]*)`
  );
  const matches = regex.exec(document.cookie);
  return matches ? decodeURIComponent(matches[1]) : null;
};
export {
  getCookie
};
